import type { Template } from "@/types";

export const LA_06_H6_V0: Template[] = [
    {
        id: "la-06-h6v0-01",
        name: "LA 01 - H6V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h6_v0_01.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 107, y: 40, width: 440, height: 289, rotation: 0, imageRotation: 0 },
            { id: "2", x: 107, y: 337, width: 217, height: 154, rotation: 0, imageRotation: 0 },
            { id: "3", x: 332, y: 337, width: 216, height: 154, rotation: 0, imageRotation: 0 },
            { id: "4", x: 803, y: 40, width: 440, height: 289, rotation: 0, imageRotation: 0 },
            { id: "5", x: 803, y: 337, width: 217, height: 154, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1028, y: 337, width: 216, height: 154, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h6v0-02",
        name: "LA 02 - H6V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h6_v0_02.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 107, y: 40, width: 440, height: 289, rotation: 0, imageRotation: 0 },
            { id: "2", x: 107, y: 337, width: 217, height: 154, rotation: 0, imageRotation: 0 },
            { id: "3", x: 332, y: 337, width: 216, height: 154, rotation: 0, imageRotation: 0 },
            { id: "4", x: 803, y: 202, width: 440, height: 288, rotation: 0, imageRotation: 0 },
            { id: "5", x: 803, y: 40, width: 217, height: 154, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1028, y: 40, width: 216, height: 154, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h6v0-03",
        name: "LA 03 - H6V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h6_v0_03.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 206, y: 0, width: 264, height: 172, rotation: 0, imageRotation: 0 },
            { id: "2", x: 206, y: 180, width: 264, height: 172, rotation: 0, imageRotation: 0 },
            { id: "3", x: 206, y: 359, width: 264, height: 172, rotation: 0, imageRotation: 0 },
            { id: "4", x: 882, y: 0, width: 264, height: 172, rotation: 0, imageRotation: 0 },
            { id: "5", x: 882, y: 180, width: 264, height: 172, rotation: 0, imageRotation: 0 },
            { id: "6", x: 882, y: 359, width: 264, height: 172, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h6v0-04",
        name: "LA 04 - H6V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h6_v0_04.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 38, y: 26, width: 338, height: 236, rotation: 0, imageRotation: 0 },
            { id: "2", x: 38, y: 269, width: 338, height: 235, rotation: 0, imageRotation: 0 },
            { id: "3", x: 384, y: 26, width: 703, height: 478, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1095, y: 26, width: 220, height: 154, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1095, y: 188, width: 220, height: 154, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1095, y: 350, width: 220, height: 153, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h6v0-05",
        name: "LA 05 - H6V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h6_v0_05.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 37, y: 26, width: 338, height: 236, rotation: 0, imageRotation: 0 },
            { id: "2", x: 37, y: 269, width: 338, height: 235, rotation: 0, imageRotation: 0 },
            { id: "3", x: 383, y: 26, width: 220, height: 154, rotation: 0, imageRotation: 0 },
            { id: "4", x: 383, y: 187, width: 220, height: 154, rotation: 0, imageRotation: 0 },
            { id: "5", x: 383, y: 349, width: 220, height: 154, rotation: 0, imageRotation: 0 },
            { id: "6", x: 611, y: 26, width: 703, height: 478, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h6v0-06",
        name: "LA 06 - H6V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h6_v0_06.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 38, y: 27, width: 220, height: 154, rotation: 0, imageRotation: 0 },
            { id: "2", x: 38, y: 188, width: 220, height: 154, rotation: 0, imageRotation: 0 },
            { id: "3", x: 38, y: 350, width: 220, height: 154, rotation: 0, imageRotation: 0 },
            { id: "4", x: 265, y: 27, width: 338, height: 236, rotation: 0, imageRotation: 0 },
            { id: "5", x: 265, y: 270, width: 338, height: 236, rotation: 0, imageRotation: 0 },
            { id: "6", x: 610, y: 27, width: 704, height: 478, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h6v0-07",
        name: "LA 07 - H6V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h6_v0_07.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 103, y: 48, width: 318, height: 214, rotation: 0, imageRotation: 0 },
            { id: "2", x: 103, y: 270, width: 318, height: 213, rotation: 0, imageRotation: 0 },
            { id: "3", x: 428, y: 48, width: 618, height: 435, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1053, y: 48, width: 195, height: 140, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1053, y: 196, width: 195, height: 139, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1053, y: 344, width: 195, height: 139, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h6v0-08",
        name: "LA 08 - H6V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h6_v0_08.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 103, width: 222, height: 159, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 270, width: 222, height: 159, rotation: 0, imageRotation: 0 },
            { id: "3", x: 229, y: 103, width: 443, height: 326, rotation: 0, imageRotation: 0 },
            { id: "4", x: 680, y: 103, width: 222, height: 159, rotation: 0, imageRotation: 0 },
            { id: "5", x: 680, y: 270, width: 222, height: 159, rotation: 0, imageRotation: 0 },
            { id: "6", x: 909, y: 103, width: 443, height: 326, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h6v0-09",
        name: "LA 09 - H6V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h6_v0_09.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 103, width: 443, height: 326, rotation: 0, imageRotation: 0 },
            { id: "2", x: 451, y: 103, width: 222, height: 159, rotation: 0, imageRotation: 0 },
            { id: "3", x: 451, y: 270, width: 222, height: 159, rotation: 0, imageRotation: 0 },
            { id: "4", x: 681, y: 103, width: 221, height: 159, rotation: 0, imageRotation: 0 },
            { id: "5", x: 681, y: 270, width: 221, height: 159, rotation: 0, imageRotation: 0 },
            { id: "6", x: 909, y: 103, width: 443, height: 326, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h6v0-10",
        name: "LA 10 - H6V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h6_v0_10.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 102, width: 222, height: 159, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 269, width: 222, height: 159, rotation: 0, imageRotation: 0 },
            { id: "3", x: 230, y: 102, width: 442, height: 326, rotation: 0, imageRotation: 0 },
            { id: "4", x: 680, y: 102, width: 442, height: 326, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1130, y: 102, width: 222, height: 159, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1130, y: 269, width: 222, height: 159, rotation: 0, imageRotation: 0 }
        ],
    }
];